export default {
  useIdToFindResourceList: {
    warning1: 'resource 必须是一个对象',
    warning2: 'prefix 必须是一个非空字符串',
    warning3: 'resourceType 必须是一个非空字符串',
    warning4: 'category 必须是一个数组',
    warning5: 'categoryId 必须是数字类型',
  },
  validator: {
    message1: '压缩包中的文件数必须是',
    message2: 'zip 包中的文件的名字要求与基础包的的文件名字相同',
    message3: '压缩包中的文件数必须是',
    message4: '压缩包中的文件命名不正确',
    message5: '压缩包中的文件数必须是',
    dragonBones: {
      errors: [
        '龙骨文件后缀必须是 _ske.json、_tex.json、_tex.png',
        '龙骨文件后缀必须是 .ani、.json、.png',
        '龙骨文件后缀必须是 .sk、.png',
      ],
      defaultError: '龙骨文件命名或文件个数不对',
    },
    model: {
      message1: '模型结构错误，1 个 fbx 内只能包含 1 个 mesh。',
      message2:
        '文件格式错误，当前替换坑位zip包内包含【fbx + 贴图】，贴图需与 fbx 绑定，并且与源文件格式保持一致。',
      message3: '文件格式错误，请上传zip格式压缩包。',
      message4:
        '文件格式错误，当前替换坑位zip包内仅包含【fbx】，请删除多余文件。',
      message5: 'zip包大小不能超过 1MB。',
      message6:
        '文件格式错误，当前替换坑位zip包内包含【fbx + 贴图】，贴图需与 fbx 绑定，并且与源文件格式保持一致。',
      tips: {
        modelRequirements: '模型要求：',
        modelRequirementsTips: [
          '1 个 fbx 内只能包含 1 个 mesh',
          '骨骼结构保持与源文件相同',
        ],
        fileRequirements: '文件要求：',
        fileRequirementsTips: [
          '格式：zip',
          '大小：< 1MB',
          'zip包内文件与源文件保持一致',
          '若zip包内包含【fbx + 贴图】，贴图需与 fbx 绑定，并且与源文件格式保持一致',
          '若zip包内仅包含【fbx】，请删除多余文件',
        ],
      },
    },
  },
  categorySearch: {
    searchText: '搜索内容',
    searchNotmatchTitle: '未找到相关结果',
    searchNotmatchDetail:
      '抱歉，没有找到符合条件的结果，建议更换不同的搜索条件。',
  },
  nav: {
    home: {
      dmaker: '定制可玩广告',
      gmaker: '可玩广告模板',
    },
    version: '版本管理',
    versionEdit: '版本编辑',
    dcoVersion: 'DCO 版本管理',
    dcoVersionEdit: 'DCO 配置',
    multiVersion: '多组合版本管理',
    multiVersionEdit: '多组合配置',
    commonTemplate: '我的作品',
  },
  languagePacks: {
    warning: '仓库语言列表中不包含',
    warning1: '语言列表中没有预设语言',
    warning2: '请选择语言',
    warning3: '请上传文件',
    error1: '读取图片失败',
    error2: '上传失败，请重新尝试',
    backup: '预设语言',
    editText: '+编辑',
    addLanguageButton: '添加语言',
    changeLanguageButton: '修改语言',
    saveLanguageButton: '保存语言',
    chooseLanguage: '选择语言',
    properties: {
      placeholder: '请填写',
      required: '文本不能为空',
    },
    defaultLanguage: '默认语言',
    isOpen: '是否对外开放新增/删除语言功能',
    open: '开放',
    close: '不开放',
    tip: '若作品包含语言未能与设备语言匹配时，将会使用此默认语言。',
    font: '字体',
    fontColor: '字体颜色',
    fontSize: '字号',
    borderThickness: '描边粗细',
    borderColor: '描边颜色',
    bold: '粗体',
    alpha: '透明度',
    italic: '斜体',
    enableShadow: '启用阴影',
    shadowColor: '阴影色',
    shadowBlur: '阴影模糊大小',
    shadowOffsetX: '阴影偏移量X',
    shadowOffsetY: '阴影偏移量Y',
    gradient: '启用渐变叠加',
    startColor: '渐变开始色',
    endColor: '渐变结束色',
    enableGlow: '启用外发光',
    glowColor: '外发光颜色',
    glowBlur: '外发光模糊大小',
    enableDeleteline: '启用删除线',
    enableUnderline: '启用下划线',
    lineHeight: '行高',
    letterSpacing: '字距',
    confirm: '确定',
    cancel: '取消',
    add: '新增',
    update: '更新',
    language: '语言',
    uploadFile: '上传文件',
    languageSelectorPlaceHolder: '请选择地区/语言',
    only: '只能上传',
    widthHeightTip: '宽高限制',
    dragUploadTip: '将文件拖到此处，或点击上传',
    leadSession: '引导环节',
    gameSession: '试玩环节',
    endSession: '结束环节',
  },
  optionalGroupItem: {
    alert: '配置错误',
    customInput: {
      placeholder: '-',
    },
    validate: {
      warning: '只能输入整数',
      warning1: '所填字符数已超过上限',
      warning2: '输入值必须大于0',
      warning3: '请输入有效的正整数',
    },
  },
  updateResourceInZipButton: {
    text: '更新',
    error: 'extra参数解析错误',
  },
  templateMixin: {
    error: '当前分类下配置内容校验不通过',
  },
  localResourceInZipDialog: {
    title: '更新',
    tips: '只能上传',
    rules: '宽高限制',
    imageUploader: {
      error: '读取图片失败',
    },
  },
  store: {
    error: '没有找到该资源',
    error1: 'JSON 解析出错',
    error2: '请完成素材的标签配置',
  },
  categoryConfig: {
    visible: '显示',
    hidden: '不显示',
    volume: '音量',
    cloud: '云端选取',
    reset: '重置',
    clear: '清除',
    linkage: '存在同一资产的位置将会被修改:',
  },
  readMode: '只读模式，该素材被编辑中',
  selectFinish: '完成选择后，前往场景内调整具体资源及玩法。',
}
